import style from './index.module.scss';

type LoadingProps = {
  width: number | string;
  height: number | string;
  radius?: number;
};

Loading.defaultProps = {
  width: 16,
  height: 16,
};

export default function Loading(props: LoadingProps) {
  return (
    <div
      className={style['skeleton-box']}
      style={{
        width: props.width,
        height: props.height,
        borderRadius: props.radius,
      }}
    />
  );
}
